import LangBinder from '../../popup/language/LanguageBinder';

import getNLS from '../../common/_NLS';


export default props=>{
  return (<div className="this-content">
    {props.noPlusButton?null:
      <div className="dibom ctn"><a href="/community/upload1"><img src="/assets/images3/ctn.svg" /></a></div>
    }
    <style jsx>{`
    /* 작성버튼 */
.ctn{
height: auto;
display:block;
position: fixed;
right: 12px;
bottom: 18px;
}

.ctn img{
  height: auto;
}

.this-content{

}



.display-inline{
  display: inline;
  margin: 0 12px 0 0;
  vertical-align: middle;
  color: white;

}

.pan8{
  margin: 100px 0 0 0;
  width: 100%;
  min-width: 1290px;
  color: white;
  background-color: #343a40;

  position: relative;
  z-index: 10;
}

.bound{
  width: 1290px;
  margin:auto;
  padding: 40px 0;
  font-size: 12px;
}
// color: #343a40;
// background-color: yellow;

.ia{
  margin: 10px;
  color: #868e96;
}

.ib{
  margin: 10px;
  color: #868e96;
  background-color: #f8f9fa;
  padding: 4px 10px;

}

.ic{
  margin: 10px;
  color: white;
  background-color: #55d5ce;
  padding: 4px 10px;
}

img {
  height: 23px;
  margin: 0 8px;
}


.rightside{
    float: right;
    text-align: right;
}


.language{
  float:right;
}


.f1{
  margin: 5px;
}


.td1{
  color: white;
}


@media all and (max-width:606px) {
  .pan8{
    width: 100%;
    min-width:100px;
  }
  .bound{
    width: 100%;
  }

  .td1{
    color: white;
    width: 100%;
  }

  div.rightside{
    float: unset;
    text-align: center;
    padding: 0 0 18px;
  }

  .icon{
    width: 16.66%;
    text-align: center;
    display: inline-block;
    margin: 10px 0;
  }

  .dark-line{
    opacity: 0.3;
    color: #adb5bd;
    margin: 15px 0;

    /* 베트남어로 하면 하단 푸터가 깨진다. 수평선에서 클리어해준다.*/
    clear: both;
  }

  .tr1{
    margin: 10px 5% 0;
  }

    
  .di-vertical-middle{
    display: inline;
    vertical-align: middle;
  }

  .bound{
    padding: 0;
  }

  .base.leftside {
    padding-left: 0;
    height: 60px;
    padding-top: 25px;
  }

  .lang-binder{
    float:right;
    height: 60px;
    padding-top: 22px;
  }

  img {
    height: 16px;
  }


}


`}</style>
    <div className="pan8">
      <div className="bound">
        <div className="table1">
          <div className="tr1">
            <div className="td1" className="dib base leftside">
              <a href="https://sites.google.com/view/camscon-corp" target="_blank"><div className="display-inline">ABOUT US</div></a>
              <a href="https://sites.google.com/view/camscon-corp/contact" target="_blank"><div className="display-inline dnom">CONTACT</div></a>
              <a href="https://sites.google.com/view/camscon-corp/recruiting" target="_blank"><div className="display-inline dnom">{getNLS("인재 채용")}</div></a>
              <a href="/htmls/opensourcelicense.html" target="_blank"><div className="display-inline dnom">오픈소스 라이센스</div></a>
              <a href="https://sites.google.com/view/camscon-corp/team" target="_blank"><div className="display-inline dnom">{getNLS("편집 팀")}</div></a>
              <a href="/htmls/terms.html" target="_blank"><div className="display-inline">{getNLS("이용약관")}</div></a>
              <a href="/htmls/privatepolicy.html" target="_blank"><div className="display-inline">{getNLS("개인정보 처리방침")}</div></a>

              <div className="dnom">
                <div className="dib td1" style={{ opacity: "0.5", paddingTop: "10px" }}>
                  제호 : 캠스콘(CAMSCON) | 인터넷신문 등록번호 : 서울 아53868 | CAMSCON CORP ALL RIGHTS RESERVED. 
                  <br />{getNLS("서울시 강남구 압구정로60길 26, 2층")} | (02)6251-2001 | information@camscon.kr
            </div>
              </div>

            </div>
            <div className="lang-binder dibom" ><LangBinder /></div>

            <div className="horizon-bar dark-line dbom" />

            <div className="dib td1" className="base rightside">
              <a href="https://youtube.com/camscontv" target="_blank"><div className="display-inline icon"><img src="/assets/images2/group-10-copy-2.svg" /></div></a>
              <a href="https://www.facebook.com/camscon" target="_blank"><div className="display-inline icon"><img src="/assets/images2/group-8-copy-2.svg" /></div></a>
              <a href="https://www.instagram.com/camscon" target="_blank"><div className="display-inline icon"><img src="/assets/images2/group-3.svg" /></div></a>
              <a href="https://m.post.naver.com/my.nhn?memberNo=10725188" target="_blank"><div className="display-inline icon"><img src="/assets/images2/group-11-copy-2.svg" /></div></a>
              <a href="https://pf.kakao.com/_BxbQxod" target="_blank"><div className="display-inline icon"><img src="/assets/images2/bitmap-copy@2x.png" /></div></a>
              <a href="https://soundcloud.com/bathhouse_official" target="_blank"><div className="display-inline icon"><img src="/assets/images2/group-13.svg" /></div></a>
            </div>
          </div>


        </div>
      </div>
    </div>



  </div>);
}